






import { Component, Prop, Vue } from 'vue-property-decorator';
import Highcharts from 'highcharts';
import { uuid } from 'vue-uuid';

@Component
export default class Chart extends Vue {

  @Prop({ type: String, default: '' }) protected title!: string;
  @Prop({ type: Array, default: [] }) protected data!: any;

  protected id: string = uuid.v1().replace(/\-/g, '');

  protected mounted() {

    let chartBlock = this.$refs[this.id] as any;

    this.data.forEach((statItem: any) => {

      chartBlock.chart.addSeries({
        name: statItem.answerText,
        data: [statItem.count],
      });

    });


    // let colors = ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"];
    // let hColor = new Highcharts.Color(colors[0]);

    // let labelColor = Highcharts.defaultOptions.title && Highcharts.defaultOptions.title.style ? Highcharts.defaultOptions.title.style.color : 'gray';

    // Highcharts.setOptions({
    //   time: {
    //     timezone: 'Europe/Moscow',
    //     timezoneOffset: -180,
    //   },
    //   lang: {
    //     shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    //     weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    //   },
    // });

  }

  protected chartOpt: any = {
    chart: {
      type: 'bar',
      height: '300px',
      backgroundColor: '#F3F2F7',
      marginLeft: '30',
      marginRight: '40',
      marginTop: '25',
      marginBottom: '140',
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    colors: [
      "#7cb5ec",
      "#434348",
      "#90ed7d",
      "#f7a35c",
      "#8085e9",
      "#f15c80",
      "#e4d354",
      "#2b908f",
      "#f45b5b",
      "#91e8e1"
    ],
    xAxis: {
      categories: [''],
      gridLineColor: '#9A99A299',
      lineColor: '#9A99A299',
      tickInterval: 1,
    },
    yAxis: {
      tickInterval: 1,
      gridLineColor: '#9A99A299',
      lineColor: '#9A99A299',
      min: 0,
      title: {
        text: 'Количество ответов'
      }
    },
    legend: {
      reversed: true
    },
    plotOptions: {
      series: {
        stacking: 'normal'
      },
      bar: {
        borderColor: '#9A99A2',
        dataLabels: {
          enabled: true
        }
      },
      line: {
        color: '#000000'
      }
    },
    series: []
  };

}

